import { gql } from "@apollo/client";

export const UpdateAnimatedProducts = gql`
mutation UpdateAnimatedProducts($updateAnimatedProductsId: ID!, $content: contentAnimatedProducts!) {
  updateAnimatedProducts(id: $updateAnimatedProductsId, content: $content) {
    status
  }
}
`;
